import React from 'react';
import styled from 'styled-components';

// Import headshot
import headshot from '../assets/headshot.jpg';

const AboutContainer = styled.div`
  padding: 40px 0;
  max-width: 800px;
  margin: 0 auto;
`;

const AboutHeading = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
  position: sticky;
  top: 180px;
  background-color: #000;
  z-index: 100;
  padding: 15px 0;
  margin-top: -15px;

  @media (max-width: 768px) {
    font-size: 1.75rem;
    top: 140px;
  }
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const HeadshotContainer = styled.div`
  width: 100%;
`;

const Headshot = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
`;

const BioText = styled.div`
  line-height: 1.6;
  
  p {
    margin-bottom: 20px;
  }
`;

function About() {
  return (
    <AboutContainer>
      <AboutHeading>About Joey M. Robinson</AboutHeading>
      
      <AboutContent>
        <HeadshotContainer>
          <Headshot src={headshot} alt="Joey M. Robinson" />
        </HeadshotContainer>
        
        <BioText>
          <p>
            Joey M. Robinson is a contemporary artist based in Seattle, Washington. His work explores themes of movement, color, and emotion through abstract expressionism.
          </p>
          
          <p>
            With a background in both traditional and experimental techniques, Joey's artistic journey spans over two decades. His distinctive style blends vibrant colors with organic forms, creating pieces that invite viewers to experience a moment of emotional resonance.
          </p>
          
          <p>
            Joey's work has been exhibited in galleries across the United States, with notable shows at the Seattle Art Museum and various private collections. His "Black Maids" series in particular has received critical acclaim for its powerful storytelling and cultural significance.
          </p>
          
          <p>
            When not in his studio, Joey enjoys teaching art workshops and mentoring emerging artists in the Seattle area.
          </p>
        </BioText>
      </AboutContent>
    </AboutContainer>
  );
}

export default About;